import { sendAnalyticsEvent } from '@devsbb/analytics-client';
import { ProductEventProperties } from './types';

export const trackProductViewed = (properties: ProductEventProperties) =>
    sendAnalyticsEvent<ProductEventProperties>('Product Viewed', properties);
